module.exports = __webpack_public_path__ + "img/bed-empty.59fd1fbe.svg";